<template>
  <div>
    <PublicLayout>
      <header
        class="header text-dark"
        :style="{
          backgroundImage: `url(${require('@/assets/public/images/products/product_header_2026.png')})`,
        }"
      >
        <div class="container">
          <h1>產品資訊</h1>
        </div>
      </header>
      <HeaderNav />
      <!-- main-section -->
      <section class="main-section">
        <section class="m-sec mb-0">
          <div class="container">
            <h2 class="section-title text-primary text-center">
              以高品質打造安心、安全的核酸製品
            </h2>
            <p>
              富地滋作為核酸營養的先驅企業，為了提供高品質的核酸製品給消費者，一直在最新的生產設備上以高標準的要求來進行生產。近年來，隨著對核酸的日益關注，我們將繼續努力提供高品質的製品，同時致力於新製品的開發。
            </p>
            <div class="row justify-content-center">
              <div class="col-sm-10 col-md-10">
                <div class="light-border-box text-center">
                  <h2 class="section-title mb-0">
                    體內體外攝取核酸營養，維持健康與美麗
                  </h2>
                  <p class="text-info mt-3">富地滋 內在+外在 營養補給的發想</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- product-toggles-section -->
        <!-- https://fordays.jp/products/ -->
        <section class="product-togglers-section">
          <div class="container">
            <h2 class="section-title text-center">富地滋產品項目</h2>
            <div class="product-togglers">
              <div class="product-toggler">
                <div
                  class="product-toggler-content"
                  v-scroll-to="'#productNormalSec'"
                >
                  <img
                    :src="
                      require('@/assets/public/images/product-toggler/nav_img_supplement_2025.png')
                    "
                    alt=""
                  />
                  <h4>營養補助食品</h4>
                </div>
              </div>
              <div class="product-toggler" v-scroll-to="'#productCareSec'">
                <div class="product-toggler-content">
                  <img
                    :src="
                      require('@/assets/public/images/product-toggler/nav_img_cosmetics_2026.png')
                    "
                    alt=""
                  />
                  <h4>保養品</h4>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- product-toggles-section -->
        <section id="productNormalSec" class="product-mousa-sec">
          <div class="container">
            <h2 class="section-title section-mousa-title">營養補助食品</h2>
            <p></p>
            <div class="row mt-4">
              <ProductListItem
                v-for="product in normalProductList"
                :key="product.id"
                :id="product.id"
                :image="product.image"
                :name="product.name"
                :subtitle="product.subtitle"
                :description="product.description"
                :imageLarge="product.imageLarge"
              />
            </div>
          </div>
        </section>
        <section id="productCareSec" class="product-mousa-sec">
          <div class="container">
            <h2 class="section-title section-mousa-title">
              夢莎LU頂級保養系列
            </h2>
            <p>
              美力覺醒！<strong>含有核酸成分</strong>，打造魅惑迷人美肌的頂級保養系列
            </p>
            <div class="row mt-4">
              <ProductListItem
                v-for="product in careProductList"
                :key="product.id"
                :id="product.id"
                :image="product.image"
                :name="product.name"
                :subtitle="product.subtitle"
                :description="product.description"
                :imageLarge="product.imageLarge"
              />
            </div>
          </div>
        </section>
        <!-- product-toggles-section -->
        <MousaProductSection />
      </section>
      <!-- main-section -->
    </PublicLayout>
  </div>
</template>

<script>
import PublicLayout from "@/components/public/PublicLayout";
import HeaderNav from "@/components/public/headerNav/productHeaderNav";
import ProductListItem from "@/components/public/ProductListItem";
import MousaProductSection from "@/components/public/MousaProductSection";
export default {
  name: "ProductsScreen",
  components: {
    PublicLayout,
    HeaderNav,
    ProductListItem,
    MousaProductSection,
  },
  data() {
    return {
      normalProductList: [
        {
          id: "1",
          name: "富地滋DN膠原",
          subtitle: "清涼飲料水",
          description:
            '邁向未來25年，兼顧自然環境，採用備受矚目的新成分──蛋白聚醣',
          image: require("@/assets/public/images/products/drink_2025-thumb-510x510-1577.png"),
          imageLarge: true,
        },
        {
          id: "2",
          name: "富地滋樂活隨身包",
          subtitle: "胺基酸補充食品(顆粒)",
          description: "維持肌肉力，保持體態平衡",
          image: require("@/assets/public/images/products/BCAA_newpkg-thumb-510x510-1421_04.png"),
          imageLarge: true,
        },
        {
          id: "11",
          name: "新夢莎ED膠原蛋白飲EX",
          subtitle: "清涼飲料水",
          description:
            "含有全新升級的鳳梨抽出物、膠原三肽、維生素C、礦物質，並新添加貓爪藤樹皮抽出物等成分均衡搭配，維持健康美麗的每一天。",
          image: require("@/assets/public/images/products/IMG_058-thumb-510x363-1106_2023.png"),
          imageLarge: true,
        },
      ],
      careProductList: [
        {
          id: "4",
          name: "LU gia 高機能美容精華液",
          subtitle: "精華液",
          description:
            "一瓶具有多重保養功效。細緻呵護肌膚的抗老化保養，賦予肌膚從未體驗過的感受。",
          image: require("@/assets/public/images/products/LU_gia高機能美容精華液.png"),
          imageLarge: true,
        },
      ],
    };
  },
};
</script>
